import React, { FC, Dispatch, SetStateAction } from 'react'
import classnames from 'classnames'
import style from './DropdownIndicator.module.css'
import { ArrowIcon } from './components/ArrowIcon'

type DropdownIndicatorProps = {
  isOpenChange: Dispatch<SetStateAction<boolean>>
  setTouch: (isTouch: boolean) => void
  inputRef: any
  isOpen: boolean
  disabled: boolean
}

export const DropdownIndicator: FC<DropdownIndicatorProps> = ({
  isOpenChange,
  setTouch,
  isOpen,
  disabled,
  inputRef,
}) => {
  const imgClassName = classnames(style.dropdownIndicatorImage, {
    [style.dropdownIndicatorHasOpened]: isOpen,
  })

  const buttonClassName = classnames(style.dropdownIndicator, {
    [style.disabled]: disabled,
  })

  const onMouseDown = () => {
    if (!disabled) {
      isOpenChange((isOpenCurrent) => !isOpenCurrent)
    }
  }

  const onClick = () => {
    if (inputRef.current && isOpen) {
      inputRef.current.focus()
    } else {
      setTouch(true)
    }
  }

  return (
    <button
      type="button"
      className={buttonClassName}
      data-creatableselectfield
      onMouseDown={onMouseDown}
      onClick={onClick}
    >
      <ArrowIcon className={imgClassName} />
    </button>
  )
}

DropdownIndicator.displayName = 'DropdownIndicator'
